import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, FileText, Trash2 } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { fileUrlAuth } from "../../api/fileUrl";
import { docStatus } from "./docStatus";
import { DocViewer } from "./DocViewer";

export const EmployeeDocRow = ({ doc, canEdit, onDelete }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const status = docStatus(doc.expiry);
  const title = t(`empDocs.types.${doc.kind}`, doc.kind);

  return (
    <li className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`emp-doc-${doc.id}`}>
      <div className="min-w-0">
        <p className="truncate text-sm font-bold">{title}</p>
        <p className="truncate text-xs text-muted-foreground">
          {[doc.title, doc.number, doc.expiry].filter(Boolean).join(" · ") || "—"}
        </p>
        {status ? (
          <p className={`mt-1 flex items-center gap-1 text-[11px] font-bold ${status.expired ? "text-danger" : "text-warning"}`}>
            <AlertTriangle className="h-3.5 w-3.5" />
            {status.expired ? t("personal.expired") : t("personal.expiresIn", { days: status.days })}
          </p>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => setOpen(true)} data-testid={`emp-doc-view-${doc.id}`}
          className="flex items-center gap-1 rounded-full px-3 py-2 text-xs font-semibold text-primary shadow-neu-sm">
          <FileText className="h-4 w-4" /> {t("personal.view")}
        </button>
        {canEdit ? (
          <NeuButton variant="danger" className="px-3 py-2" data-testid={`emp-doc-delete-${doc.id}`} onClick={() => onDelete(doc)}>
            <Trash2 className="h-4 w-4" />
          </NeuButton>
        ) : null}
      </div>
      <DocViewer open={open} url={fileUrlAuth(doc.file_url)} title={title} onClose={() => setOpen(false)} />
    </li>
  );
};
